import React from "react";
import { useState, useEffect } from "react";
import Edit from "./Edit";
import BhinaMembers from "../bhinamembermanager/BhinaMembers";
import Documents from "./documents/Documents";
import Emails from "./emails/Emails";
import EmailsForMembers from "./InviteMembers/EmailsForMembers";
import HazmanatMoamadeem from "./HazmanatMoamadeem";
import Protocol from "./Protocol";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { ImForward } from "react-icons/im";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

const BhinaMeetingAdmin = (props) => {
  const { mekhraz_id, department } = useParams();
  const axiosPrivate = useAxiosPrivate("application/json");
  const location = useLocation();
  const [protocolChanged, setProtocolChanged] = useState(false);
  const [page, setPage] = useState(1);
  const [meeting, setMeeting] = useState(null);
  const [mekhraz, setMekhraz] = useState(null);
  const [newM, setNewM] = useState(null);
  const [newRecord, setNewRecord] = useState(1);
  const [loading, setLoading] = useState(true);
  const [lastTenMeetings, setLastTenMeetings] = useState(null);
  const navigate = useNavigate();
  let history = useNavigate();
  const handlePageChange = (newPage) => {
    if (protocolChanged) {
      const confirm = window.confirm(
        "השינויים לא נשמרו. האם אתה בטוח שברצונך לעזוב?",
      );
      if (!confirm) return;
    }
    setPage(newPage);
  };
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getBhinaMeeting = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "bhinameeting?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setMeeting(response.data[0]);
          setNewM(response.data[0]);
          setNewRecord(response.data.length);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    const getLastBhinaMeeting = async () => {
      try {
        //-10 means get the last 10 meetings
        const response = await axiosPrivate.get(
          baseURL + "bhinameeting?mekhraz_id=" + "0",
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setLastTenMeetings(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    const getMekhraz = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "mekhraz/" + mekhraz_id,
          {
            signal: controller.signal,
          },
        );
        isMounted && setMekhraz(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    const getData = async () => {
      getLastBhinaMeeting();
      getBhinaMeeting();
      getMekhraz();
      setLoading(false);
    };
    getData();
  }, []);
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <nav className="navbar navbar-expand-md bg-dark navbar-dark fixed-right ">
          <a href="#" className="navbar-brand mb-0 h1">
            ניהול ישיבת <br />
            ועדת הבחינה
          </a>

          <ul className="navbar-nav flex-column ml-auto">
            <li className="nav-item ">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => history(-1)}
              >
                <ImForward />
                חזרה
              </button>
            </li>

            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(1)}
              >
                עריכה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(3)}
                disabled={meeting ? false : true}
              >
                הרכב הוועדה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(7)}
                disabled={meeting ? false : true}
              >
                ההזמנות של חברי הוועדה
              </button>
            </li>
            <li>
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(4)}
                disabled={meeting ? false : true}
              >
                זימון המועמדים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(5)}
                disabled={meeting ? false : true}
              >
                ההזמנות של המועמדים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(6)}
                disabled={meeting ? false : true}
              >
                מסמכים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(8)}
                disabled={meeting ? false : true}
              >
                פרוטוקול
              </button>
            </li>
          </ul>
        </nav>
        <div style={{ paddingRight: "90px" }}>
          {page === 1 && (
            <Edit
              visible={page == 1}
              newM={newM}
              setNewM={setNewM}
              setMeeting={setMeeting}
              mekhraz_id={mekhraz_id}
              mekhraz={mekhraz}
              setMekhraz={setMekhraz}
              newRecord={newRecord}
              setNewRecord={setNewRecord}
              lastTenMeetings={lastTenMeetings}
            />
          )}
          {page === 3 && (
            <BhinaMembers
              visible={page == 3}
              meeting={meeting}
              id={meeting ? meeting.id : -1}
            />
          )}

          {page === 4 && meeting && (
            <HazmanatMoamadeem
              visible={page == 4}
              mekhraz_id={mekhraz_id}
              meetingTime={newM.start_time}
              meeting={meeting}
              mekhraz_num={mekhraz.mkh_num}
              mekhraz_title={mekhraz.title}
            />
          )}
          {page === 5 && meeting && (
            <Emails visible={page == 5} bhinaMeeting={meeting} />
          )}
          {page === 6 && meeting && (
            <Documents visible={page == 6} bhinameeting={meeting} />
          )}
          {page === 7 && meeting && (
            <EmailsForMembers visible={page == 7} bhinaMeeting={meeting} />
          )}
          {page === 8 && meeting && (
            <Protocol
              visible={page == 8}
              mekhraz={mekhraz}
              bhinaMeeting={meeting}
              setBhinaMeeting={setMeeting}
              department={department}
              onLeave={handlePageChange}
              onChangedStatus={setProtocolChanged}
            />
          )}
        </div>
      </>
    );
  }
};

export default BhinaMeetingAdmin;
